<!--
 * @Description  : 打开新页面的预览
 * @Author       : 王帅
 * @Date         : 2023-07-06 11:24:44
 * @LastEditors  : git config user.sname
 * @LastEditTime : 2025-10-21 16:51:49
 * @FilePath     : \ngs_platform_manage_admin\src\components\bm-preview\preview-online.vue
-->
<template>
	<div class="full-preview" v-show="showPreview">
		<div class="preview-title">
			<span class="text-overflow">{{ previewName }}</span>
		</div>
		<div class="preview-content">
			<iframe :src="previewUrl" frameborder="0" width="100%" height="100%"></iframe>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { bmStorage } from '../../utils/tools'

export default {
	name: '',
	data() {
		return {
			showPreview: false
		}
	},
	created() {
		if (bmStorage.localStorage.get('previewUrl')) {
			this.setPreviewUrl(bmStorage.localStorage.get('previewUrl'))
			this.setPreviewName(bmStorage.localStorage.get('fileName'))
		}
	},
	mounted() {
		// 关闭
		// window.addEventListener('unload', e => {
		// 	if (bmStorage.localStorage.get('previewUrl')) {
		// 		bmStorage.localStorage.remove('previewUrl')
		// 		bmStorage.localStorage.remove('fileName')
		// 	}
		// })
	},
	methods: {
		...mapActions('app', ['setPreviewUrl', 'setPreviewName']),
		// 关闭
		closePreview() {
			this.setPreviewUrl('')
			this.setPreviewName('')
		}
	},
	computed: {
		...mapState('app', {
			previewUrl: (state) => state.previewUrl,
			previewName: (state) => state.previewName
		})
	},
	watch: {
		previewUrl: {
			handler: function (url) {
				if (!!url) {
					this.showPreview = true
				} else {
					this.showPreview = false
				}
			},
			deep: true
		}
	}
}
</script>

<style scoped lang="less">
.full-preview {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 100000;
	background-color: #fff;

	.preview-title {
		height: 40px;
		line-height: 40px;
		display: flex;
		justify-content: space-between;
		padding: 0 20px;
		font-size: 16px;
		border-bottom: 1px solid #ccc;
		color: #3ba1ff;

		.close-icon {
			line-height: 40px;
			font-size: 20px;
			cursor: pointer;
			font-weight: 700;
			color: #000;
		}

		.close-icon:hover {
			color: #ff5722;
		}
	}

	.preview-content {
		height: calc(~'100% - 40px');
	}
}
</style>
